import { Pressable } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { View, Text } from "@src/components";
import { Icon } from "@src/components/Icon";
import type { TestSignalAction } from "../actions";

interface TestSignalActionCardProps {
  action: TestSignalAction;
  disabled: boolean;
  onPress: () => void;
}

/**
 * One delivery leg, as a card rather than a settings row.
 *
 * A row puts the title and its subtitle at opposite ends of the container, so
 * on a wide display the two drift apart and the pair reads as unrelated. Here
 * the subtitle sits under the title it belongs to, and the card takes a share
 * of the row instead of the full page width.
 */
export function TestSignalActionCard({ action, disabled, onPress }: TestSignalActionCardProps) {
  const { theme } = useUnistyles();

  return (
    <Pressable onPress={disabled ? undefined : onPress} disabled={disabled} style={{ flexGrow: 1, flexBasis: 280 }}>
      <View
        bg="surfaceCard"
        borderRadius={theme.spacing.lg}
        borderWidth={1}
        borderColor="borderCard"
        p="3xl"
        gap="lg"
        style={{ opacity: disabled ? 0.5 : 1 }}
      >
        <View flexDirection="row" alignItems="center" gap="xl">
          <Icon name="send" size={20} color={theme.colors.interactive.controls.default_midground} />
          <Text textStyle="sm/semibold" color="text">
            {action.title}
          </Text>
        </View>
        <Text textStyle="sm/regular" color="textMuted">
          {action.subtitle}
        </Text>
      </View>
    </Pressable>
  );
}
